export type EmailTypography =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p1"
  | "p2"
  | "p3";

export type EmailActionSidebarViewType =
  | "emailH1TextStyles"
  | "emailH2TextStyles"
  | "emailH3TextStyles"
  | "emailH4TextStyles"
  | "emailH5TextStyles"
  | "emailH6TextStyles"
  | "emailP1TextStyles"
  | "emailP2TextStyles"
  | "emailP3TextStyles";

export const EMAIL_ACTION_SIDEBAR_VIEW_MAP: Record<
  EmailActionSidebarViewType,
  EmailTypography
> = {
  emailH1TextStyles: "h1",
  emailH2TextStyles: "h2",
  emailH3TextStyles: "h3",
  emailH4TextStyles: "h4",
  emailH5TextStyles: "h5",
  emailH6TextStyles: "h6",
  emailP1TextStyles: "p1",
  emailP2TextStyles: "p2",
  emailP3TextStyles: "p3",
};

export const getTypographyTokenFromActionView = (
  actionSidebarView: string,
): EmailTypography | undefined =>
  EMAIL_ACTION_SIDEBAR_VIEW_MAP[
    actionSidebarView as EmailActionSidebarViewType
  ];

export const isEmailActionSidebarViewType = (
  value: string,
): value is EmailActionSidebarViewType =>
  value in EMAIL_ACTION_SIDEBAR_VIEW_MAP;
